"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.personalCreditCards = exports.getPersonalCreditCardsSlice = exports.getPersonalCreditCardsLastSuccess = exports.getPersonalCreditCardsLastError = exports.getPersonalCreditCardsError = exports.getPersonalCreditCardsData = exports.getPersonalCreditCards = exports.getHasPersonalCreditCardsLoadedSuccessfully = exports.getHasBusinessCreditCardsLoadedSuccessfully = exports.getHasAPersonalCreditCardsFetchFinished = exports.getHasABusinessCreditCardsFetchFinished = exports.getBusinessCreditCardsSlice = exports.getBusinessCreditCardsLastSuccess = exports.getBusinessCreditCardsLastError = exports.getBusinessCreditCardsError = exports.getBusinessCreditCardsData = exports.getBusinessCreditCards = exports.getArePersonalCreditCardsLoading = exports.getAreBusinessCreditCardsLoading = exports["default"] = exports.businessCreditCards = void 0;

var _lodash = _interopRequireDefault(require("lodash.get"));

var _reselect = require("reselect");

var _utils = require("@navinc/utils");

var _actions = require("./actions");

var _updatePlsUrlLoggedOut = require("../util/update-pls-url-logged-out");

var personalCreditCards = (0, _utils.createFetchReducer)({
  loadActionType: _actions.PERSONAL_CREDIT_CARDS_LOAD,
  failureActionType: _actions.PERSONAL_CREDIT_CARDS_FAILURE,
  successActionType: _actions.PERSONAL_CREDIT_CARDS_SUCCESS
});
exports.personalCreditCards = personalCreditCards;
var businessCreditCards = (0, _utils.createFetchReducer)({
  loadActionType: _actions.BUSINESS_CREDIT_CARDS_LOAD,
  failureActionType: _actions.BUSINESS_CREDIT_CARDS_FAILURE,
  successActionType: _actions.BUSINESS_CREDIT_CARDS_SUCCESS
});
exports.businessCreditCards = businessCreditCards;

var _default = function _default(state, action) {
  switch (action.type) {
    case _actions.PERSONAL_CREDIT_CARDS_LOAD:
    case _actions.PERSONAL_CREDIT_CARDS_FAILURE:
    case _actions.PERSONAL_CREDIT_CARDS_SUCCESS:
      {
        var newPersonalCC = personalCreditCards(state.personalCreditCards, action);
        return state.personalCreditCards === newPersonalCC ? state : {
          businessCreditCards: state.businessCreditCards,
          personalCreditCards: newPersonalCC
        };
      }

    case _actions.BUSINESS_CREDIT_CARDS_LOAD:
    case _actions.BUSINESS_CREDIT_CARDS_FAILURE:
    case _actions.BUSINESS_CREDIT_CARDS_SUCCESS:
      {
        var newBusinessCC = businessCreditCards(state.businessCreditCards, action);
        return state.businessCreditCards === newBusinessCC ? state : {
          businessCreditCards: newBusinessCC,
          personalCreditCards: state.personalCreditCards
        };
      }

    default:
      {
        return state;
      }
  }
};

exports["default"] = _default;

var _createBaseSelectors = (0, _utils.createBaseSelectors)('personalCreditCards'),
    getPersonalCreditCardsSlice = _createBaseSelectors.getSlice,
    getArePersonalCreditCardsLoading = _createBaseSelectors.getIsLoading,
    getPersonalCreditCardsLastError = _createBaseSelectors.getLastError,
    getPersonalCreditCardsLastSuccess = _createBaseSelectors.getLastSuccess,
    getPersonalCreditCardsDataRaw = _createBaseSelectors.getData,
    getPersonalCreditCardsError = _createBaseSelectors.getError,
    getHasAPersonalCreditCardsFetchFinished = _createBaseSelectors.getHasAFetchFinished,
    getHasPersonalCreditCardsLoadedSuccessfully = _createBaseSelectors.getHasLoadedSuccessfully;

exports.getHasPersonalCreditCardsLoadedSuccessfully = getHasPersonalCreditCardsLoadedSuccessfully;
exports.getHasAPersonalCreditCardsFetchFinished = getHasAPersonalCreditCardsFetchFinished;
exports.getPersonalCreditCardsError = getPersonalCreditCardsError;
exports.getPersonalCreditCardsLastSuccess = getPersonalCreditCardsLastSuccess;
exports.getPersonalCreditCardsLastError = getPersonalCreditCardsLastError;
exports.getArePersonalCreditCardsLoading = getArePersonalCreditCardsLoading;
exports.getPersonalCreditCardsSlice = getPersonalCreditCardsSlice;
var getPersonalCreditCardsData = (0, _reselect.createSelector)(getPersonalCreditCardsDataRaw, function (data) {
  var _data$personalCreditC;

  if (!data) {
    return data;
  }

  return Object.assign({}, data, {
    personalCreditCards: (_data$personalCreditC = data.personalCreditCards) === null || _data$personalCreditC === void 0 ? void 0 : _data$personalCreditC.map(function (creditCard) {
      return Object.assign({}, creditCard, {
        applyUrl: (0, _updatePlsUrlLoggedOut.updatePLSUrlLoggedOut)(creditCard.applyUrl)
      });
    })
  });
});
exports.getPersonalCreditCardsData = getPersonalCreditCardsData;
var getPersonalCreditCards = (0, _reselect.createSelector)(getPersonalCreditCardsData, function (personalCreditCards) {
  return (0, _lodash["default"])(personalCreditCards, 'personalCreditCards', []);
});
exports.getPersonalCreditCards = getPersonalCreditCards;

var _createBaseSelectors2 = (0, _utils.createBaseSelectors)('businessCreditCards'),
    getBusinessCreditCardsSlice = _createBaseSelectors2.getSlice,
    getAreBusinessCreditCardsLoading = _createBaseSelectors2.getIsLoading,
    getBusinessCreditCardsLastError = _createBaseSelectors2.getLastError,
    getBusinessCreditCardsLastSuccess = _createBaseSelectors2.getLastSuccess,
    getBusinessCreditCardsDataRaw = _createBaseSelectors2.getData,
    getBusinessCreditCardsError = _createBaseSelectors2.getError,
    getHasABusinessCreditCardsFetchFinished = _createBaseSelectors2.getHasAFetchFinished,
    getHasBusinessCreditCardsLoadedSuccessfully = _createBaseSelectors2.getHasLoadedSuccessfully;

exports.getHasBusinessCreditCardsLoadedSuccessfully = getHasBusinessCreditCardsLoadedSuccessfully;
exports.getHasABusinessCreditCardsFetchFinished = getHasABusinessCreditCardsFetchFinished;
exports.getBusinessCreditCardsError = getBusinessCreditCardsError;
exports.getBusinessCreditCardsLastSuccess = getBusinessCreditCardsLastSuccess;
exports.getBusinessCreditCardsLastError = getBusinessCreditCardsLastError;
exports.getAreBusinessCreditCardsLoading = getAreBusinessCreditCardsLoading;
exports.getBusinessCreditCardsSlice = getBusinessCreditCardsSlice;
var getBusinessCreditCardsData = (0, _reselect.createSelector)(getBusinessCreditCardsDataRaw, function (data) {
  var _data$businessCreditC;

  if (!data) {
    return data;
  }

  return Object.assign({}, data, {
    businessCreditCards: (_data$businessCreditC = data.businessCreditCards) === null || _data$businessCreditC === void 0 ? void 0 : _data$businessCreditC.map(function (creditCard) {
      return Object.assign({}, creditCard, {
        applyUrl: (0, _updatePlsUrlLoggedOut.updatePLSUrlLoggedOut)(creditCard.applyUrl)
      });
    })
  });
});
exports.getBusinessCreditCardsData = getBusinessCreditCardsData;
var getBusinessCreditCards = (0, _reselect.createSelector)(getBusinessCreditCardsData, function (businessCreditCards) {
  return (0, _lodash["default"])(businessCreditCards, 'businessCreditCards', []);
});
exports.getBusinessCreditCards = getBusinessCreditCards;
//# sourceMappingURL=reducer.js.map